import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isSelected", "selectedPanelRef", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { StyledTabPanel } from './TabPanel.styles';
import { assignRef } from '../../../tools';
import { jsx as _jsx } from "react/jsx-runtime";
var TabPanel = forwardRef(function (_ref, _ref2) {
  var children = _ref.children,
      isSelected = _ref.isSelected,
      selectedPanelRef = _ref.selectedPanelRef,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 2 : _ref$id,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(StyledTabPanel, _objectSpread(_objectSpread({
    ref: function ref(node) {
      if (isSelected) {
        assignRef(selectedPanelRef, node);
      }

      assignRef(_ref2, node);
    },
    role: "tabpanel",
    tabIndex: "-1",
    "aria-labelledby": "tab:".concat(id),
    hidden: !isSelected,
    id: "panel:".concat(id)
  }, rest), {}, {
    children: children
  }));
});
export default TabPanel;